import { Box, Grid, Link, Typography } from '@mui/material';
import Image from 'next/image';

// import moment from 'moment';
// import { useState } from 'react';

const BlogContentExtension = () => {
  // const router = useRouter();
  // const [blogItems, setBolgItems] = useState<any[]>([]);
  // async function fetchData() {
  //   await fetch(
  //     'https://api.rss2json.com/v1/api.json?rss_url=https://blog.taxzerone.com/feed/'
  //   )
  //     .then(async (result: any) => {
  //       const data = await result.json();
  //       const { items } = data;
  //       let temp = 0;
  //       const list: any[] = [];
  //       items.forEach((row: any) => {
  //         if (temp < 3) {
  //           list.push({
  //             link: row.link.replace(
  //               'https://blogtaxzerone.wpcomstaging.com/',
  //               'https://blog.taxzerone.com/posts/'
  //             ),
  //             imglink: row.link.replace(
  //               'https://blogtaxzerone.wpcomstaging.com/',
  //               'https://blogtaxzerone.wpcomstaging.com/wp-content/uploads/'
  //             ),
  //             title: row.title,
  //             content: row.description,
  //             date: moment(row.pubDate).format('MMM DD, YYYY'),
  //             image: row.imglink,
  //           });
  //           temp += 1;
  //         }
  //       });
  //       //  setBolgItems(list);
  //     })
  //     .catch((error) => {
  //       // eslint-disable-next-line no-console
  //       console.error(error);
  //     });
  // }

  // useEffect(() => {
  //   if (router.isReady) {
  //     fetchData();
  //   }
  // }, [router.isReady]);

  return (
    <>
      {/* {blogItems.map((item: any, index) => (
        <Grid
          item
          xs={12}
          md={4}
          sm={4}
          key={index}
          
          textAlign="left"
        >
          <Box
            sx={{
              border: '1px solid #eaeaea',
              p: 1.5,
              backgroundColor: '#fff',
              pb: { xs: 2, sm: 2 },
              borderRadius: 3,
              minHeight: '100%',
            }}
          >
            <Link
              href={item.link}
              target={'_blank'}
              rel="noreferrer"
              sx={{
                color: '#333',
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              <Box
                sx={{
                  borderRadius: 2,
                  overflow: 'hidden',
                  position: 'relative',
                  mb: 2,
                  '& img': {
                    transform: 'scale(1)',
                    transition: 'all .3s ease',
                    //  objectFit: 'cover',
                    width: '100%',
                    height: 'auto',
                  },
                  '& img:hover': { transform: 'scale(1.11)' },
                }}
              >
                <img
                  src={`${item.imglink}.png`}
                  alt={item.title}
                  width={394}
                  height={251}
                />
              </Box>

              <Typography
                variant="h3"
                sx={{
                  fontSize: { xs: 16, md: 16 },
                  mb: { xs: 1, sm: 1 },
                  fontWeight: 600,
                  minHeight: { xs: 1, sm: 35 },
                }}
              >
                {item.title}
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  maxHeight: 'none',
                  overflow: 'hidden',
                  display: '-webkit-box',
                  wordBreak: 'break-word',
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: 'vertical',
                  mt: 1,
                }}
              >
                <small
                  style={{
                    fontWeight: 500,
                    fontStyle: 'italic',
                    color: '#7b7b7b',
                  }}
                >
                  {item.date}
                </small>
                <br />
                {item.content}
              </Typography>
            </Link>
          </Box>
        </Grid>
      ))} */}
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Box
          sx={{
            border: '1px solid #eaeaea',
            p: 1.5,
            backgroundColor: '#fff',
            pb: { xs: 2, sm: 2 },
            borderRadius: 3,
            minHeight: '100%',
          }}
        >
          <Link
            href="https://blog.taxzerone.com/posts/do-you-need-extra-time-to-file-your-business-taxes-extend-the-deadline-with-form-7004/"
            target="_blank"
            sx={{
              color: '#333',
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            <Box
              sx={{
                overflow: 'hidden',
                position: 'relative',
                border: '6px solid #42453f !important',
                borderRadius: 3,
                maxHeight: { xs: 183, sm: 134, md: 190, lg: 207 },
                mb: 2,
                '& img': {
                  transform: 'scale(1)',
                  transition: 'all .3s ease',
                  //  objectFit: 'cover',
                  width: '100%',
                  height: 'auto',
                },
                '& img:hover': { transform: 'scale(1.11)' },
              }}
            >
              <Image
                src="https://blog.taxzerone.com/wp-content/uploads/business-tax-extension-form.jpg"
                alt="Do you need extra time to file your Business Taxes?"
                width={394}
                height={247}
              />
            </Box>

            <Typography
              variant="h3"
              sx={{
                fontFamily: 'Poppins',
                fontSize: { xs: 16, md: 16 },
                mb: { xs: 1, sm: 1 },
                fontWeight: 600,
                minHeight: { xs: 1, sm: 35 },
              }}
            >
              Do you need extra time to file your Business Taxes? Extend the
              deadline with Form 7004
            </Typography>

            <Typography
              variant="body2"
              sx={{
                fontFamily: 'Poppins',
                maxHeight: 'none',
                overflow: 'hidden',
                display: '-webkit-box',
                wordBreak: 'break-word',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                mt: 1,
              }}
            >
              <small
                style={{
                  fontFamily: 'Poppins',
                  fontWeight: 500,
                  fontStyle: 'italic',
                }}
              >
                March 6, 2025
              </small>
              <br />
              As an entrepreneur, running a business often feels like a constant
              balancing act. Even for the most organized, tax filing deadlines
              can unexpectedly creep up.
            </Typography>
          </Link>
        </Box>
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Box
          sx={{
            border: '1px solid #eaeaea',
            p: 1.5,
            backgroundColor: '#fff',
            pb: { xs: 2, sm: 2 },
            borderRadius: 3,
            minHeight: '100%',
          }}
        >
          <Link
            href="https://blog.taxzerone.com/posts/e-file-form-7004-in-seconds-with-taxzerones-click2file/"
            target="_blank"
            sx={{
              color: '#333',
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            <Box
              sx={{
                overflow: 'hidden',
                position: 'relative',
                border: '6px solid #42453f !important',
                borderRadius: 3,
                maxHeight: { xs: 183, sm: 134, md: 190, lg: 207 },
                mb: 2,
                '& img': {
                  transform: 'scale(1)',
                  transition: 'all .3s ease',
                  //  objectFit: 'cover',
                  width: '100%',
                  height: 'auto',
                },
                '& img:hover': { transform: 'scale(1.11)' },
              }}
            >
              <Image
                src="https://blog.taxzerone.com/wp-content/uploads/taxzerone-click2file.jpg"
                alt="E-File Form 7004 in seconds with TaxZerone’s Click2File"
                width={394}
                height={247}
              />
            </Box>

            <Typography
              variant="h3"
              sx={{
                fontFamily: 'Poppins',
                fontSize: { xs: 16, md: 16 },
                mb: { xs: 1, sm: 1 },
                fontWeight: 600,
                minHeight: { xs: 1, sm: 35 },
              }}
            >
              E-File Form 7004 in seconds with TaxZerone&apos;s Click2File
            </Typography>

            <Typography
              variant="body2"
              sx={{
                fontFamily: 'Poppins',
                maxHeight: 'none',
                overflow: 'hidden',
                display: '-webkit-box',
                wordBreak: 'break-word',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                mt: 1,
              }}
            >
              <small
                style={{
                  fontFamily: 'Poppins',
                  fontWeight: 500,
                  fontStyle: 'italic',
                }}
              >
                February 8, 2024
              </small>
              <br />
              Click2File allows you to easily transfer last year’s data to your
              current return, saving time & reducing errors. File Form 7004 in
              seconds with TaxZerone
            </Typography>
          </Link>
        </Box>
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }} textAlign="left">
        <Box
          sx={{
            border: '1px solid #eaeaea',
            p: 1.5,
            backgroundColor: '#fff',
            pb: { xs: 2, sm: 2 },
            borderRadius: 3,
            minHeight: '100%',
          }}
        >
          <Link
            href="https://blog.taxzerone.com/posts/form-7004-instructions/"
            target="_blank"
            sx={{
              color: '#333',
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            <Box
              sx={{
                overflow: 'hidden',
                position: 'relative',
                border: '6px solid #42453f !important',
                borderRadius: 3,
                maxHeight: { xs: 183, sm: 134, md: 190, lg: 207 },
                mb: 2,
                '& img': {
                  transform: 'scale(1)',
                  transition: 'all .3s ease',
                  //  objectFit: 'cover',
                  width: '100%',
                  height: 'auto',
                },
                '& img:hover': { transform: 'scale(1.11)' },
              }}
            >
              <Image
                src="https://blog.taxzerone.com/wp-content/uploads/form-7004-instructions.jpg"
                alt="Form 7004 Instructions"
                width={394}
                height={247}
              />
            </Box>

            <Typography
              variant="h3"
              sx={{
                fontFamily: 'Poppins',
                fontSize: { xs: 16, md: 16 },
                mb: { xs: 1, sm: 1 },
                fontWeight: 600,
                minHeight: { xs: 1, sm: 35 },
              }}
            >
              Form 7004 Instructions
            </Typography>

            <Typography
              variant="body2"
              sx={{
                fontFamily: 'Poppins',
                maxHeight: 'none',
                overflow: 'hidden',
                display: '-webkit-box',
                wordBreak: 'break-word',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                mt: 1,
              }}
            >
              <small
                style={{
                  fontFamily: 'Poppins',
                  fontWeight: 500,
                  fontStyle: 'italic',
                }}
              >
                March 29, 2023
              </small>
              <br />
              What is IRS Form 7004? IRS Form 7004, known as the Application for
              Automatic Extension of Time to File Certain Business Income Tax,
              Information, and Other Returns, allows U.S.
            </Typography>
          </Link>
        </Box>
      </Grid>
    </>
  );
};

export default BlogContentExtension;
